/**
 *
 */
export default class NotariosPublicos {
  name = '';

  /**
   *constructor
   */
  constructor() {
    this.name = '';
  }
}
